// AI Prompt constants moved here to avoid cross-library import issues
export const AI_PROMPT_TITLE = {
  "Short & Concise":
    "You are a news editor crafting video titles for a newsroom CMS. Rewrite the title in ≤50 characters. Prioritize clarity, immediacy, and SEO keywords. Make it instantly scannable for YouTube, X, and Insta feeds while credible enough for apps and LinkedIn.",
  Factual:
    "You are a factual news editor who rewrites titles in ≤60 characters with an authoritative, SEO-optimized, and credible tone for YouTube, apps, and LinkedIn, highlighting verified facts, numbers, or authority figures when possible, and if the input is vague, random, non-news, or lacks factual context, return the original title unchanged without asking questions, explanations, or clarification, and output only the final title.",
  Conversational:
    "You are a news editor adapting content for younger, social-first audiences. Rewrite the title in ≤55 characters using a relatable, conversational tone — like explaining the news to a friend. Keep it SEO-friendly and accessible and if the input is vague, random, non-news, or lacks conversational context, return the original title unchanged without asking questions, explanations, or clarification, and output only the final title.",
  Dramatic:
    "You are a news editor aiming to dramatize a headline without sensationalism. Rewrite the title in ≤60 characters with urgency, conflict, or contrast. Use strong verbs and hooks to drive curiosity while staying factual.",
  Viral:
    "You are a news editor rewriting for virality and shareability. Rewrite the title in ≤60 characters using trending keywords, emotional triggers, or curiosity gaps. Optimize for YouTube discovery and cross-platform shares.",
};

export const AI_PROMPT_DESC = {
  "Short & Concise":
    "As a newsroom content editor, rewrite the description in ≤150 characters. Deliver the essence of the story in one impactful line, front-loaded with SEO-friendly keywords. Ensure it hooks audiences on YouTube previews and remains professional for news sites.",
  Factual:
    "You are preparing a factual news description. Expand with key data points, verified sources, or official statements. Keep the first 2 lines impactful for YouTube preview text. Ensure tone is professional, credible, and searchable on news apps.",
  Conversational:
    "As a content editor shaping conversational news, rewrite the description with a friendly, inclusive voice. Use plain language and short sentences. Balance relatability for Insta and X with clarity for YouTube and apps, while keeping SEO terms intact.",
  Dramatic:
    "As a dramatic storyteller in a newsroom, rewrite the description to build tension and stakes. Use context to show why this news matters, ending with a subtle cliffhanger. Keep SEO keywords intact and make it engaging across YouTube and social feeds.",
  Viral:
    "As a viral-focused news editor, rewrite the description to highlight the most surprising or emotional element. Add 2–3 natural hashtags for discoverability. Keep it short, punchy, and engaging across Insta, X, and YouTube, while SEO-aligned for news apps.",
};
export const fileProcessingStatusToTextAndColor = (
  status: number
): {
  statusTextColor: string | undefined;
  statusText: string;
  statusColor: string;
} => {
  const result = {
    statusText: "unknown",
    statusColor: "red",
    statusTextColor: "#fff",
    tooltipText: "",
  };

  switch (status) {
    case 1:
      result.statusText = "Created";
      result.statusColor = "created";
      // result.statusTextColor = 'text-primary';
      break;
    case 2:
      result.statusText = "Uploading";
      result.statusColor = "bg-secondary-subtle";
      result.statusTextColor = "text-secondary";
      break;
    case 3:
      result.statusText = "Uploaded";
      result.statusColor = "bg-danger";
      result.statusTextColor = "text-danger";
      break;
    case 4:
      result.statusText = "Verified";
      result.statusColor = "bg-primary";
      result.statusTextColor = "text-primary";
      break;
    // case 5:
    //   result.statusText = 'Queued - Processing';
    //   result.statusColor = 'bg-warning';
    //   result.statusTextColor = 'text-warning';
    //   break;
    case 6:
      result.statusText = "Queued";
      result.statusColor = "bg-info";
      result.statusTextColor = "text-info";
      break;
    case 7:
      result.statusText = "Processing";
      result.statusColor = "processing";
      result.tooltipText = "Processing";
      // result.statusTextColor = 'text-info';
      break;
    case 8:
      result.statusText = "Processing ";
      result.statusColor = "processing";
      // result.statusTextColor = 'text-info';
      break;
    case 9:
      result.statusText = "Verifying";
      result.statusColor = "bg-primary";
      result.statusTextColor = "text-primary";
      break;
    case 10:
      result.statusText = "Ready";
      result.statusColor = "bg-info";
      result.statusTextColor = "text-info";
      break;
    case 11:
      result.statusText = "Archived";
      result.statusColor = "bg-info";
      result.statusTextColor = "text-info";
      break;
    case 12:
      result.statusText = "Deleted";
      result.statusColor = "bg-info";
      result.statusTextColor = "text-info";
      break;
    case -2:
      result.statusText = "Uploading Interrupted";
      result.statusColor = "bg-danger";
      result.statusTextColor = "text-danger";
      break;
    case -3:
      result.statusText = "Uploading Failed";
      result.statusColor = "bg-danger";
      // result.statusTextColor = 'text-danger';
      break;
    case -4:
      result.statusText = "Verifying Failed";
      result.statusColor = "deleted";
      // result.statusTextColor = 'text-danger';
      break;
    case -6:
      result.statusText = "Queued Failed";
      result.statusColor = "deleted";
      // result.statusTextColor = 'text-danger';
      break;
    case -7:
      result.statusText = "Processing Failed";
      result.statusColor = "deleted";
      // result.statusTextColor = 'text-danger';
      break;
    case -8:
      result.statusText = "CDN Uploading Failed";
      result.statusColor = "deleted";
      // result.statusTextColor = 'text-danger';
      break;
    case -9:
      result.statusText = "Verification Failed";
      result.statusColor = "deleted";
      // result.statusTextColor = 'text-danger';
      break;
    case -10:
      result.statusText = "Ready Failed";
      result.statusColor = "deleted";
      // result.statusTextColor = 'text-danger';
      break;
    case -11:
      result.statusText = "Archived Failed";
      result.statusColor = "deleted";
      // result.statusTextColor = 'text-danger';
      break;
    case -12:
      result.statusText = "Deleted Failed";
      result.statusColor = "deleted";
      // result.statusTextColor = 'text-danger';
      break;
    default:
      result.statusText = "Processing";
      result.statusColor = "processing";
      // result.statusTextColor = 'text-info';
      break;
  }

  return result;
};

// MEDIA_STATUS_DRAFT: 0,
//   MEDIA_STATUS_PUBLISHING: 1,
//   MEDIA_STATUS_PUBLISHED: 2,
//   MEDIA_STATUS_INACTIVE: 3,
//   MEDIA_STATUS_DELETED: -2,
//   MEDIA_STATUS_ERROR: -3,

export const socialPublishStatusTooltipText = (status: number): string => {
  const result = { text: "Tooltip Text" };
  switch (status) {
    case 12:
      result.text = "Your content is in draft, mark it active to publish";
      break;
    case 0:
      result.text =
        "Your content is in draft, will start uploading once the content is activated";
      break;
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 7:
      result.text = "Your upload is in progress";
      break;

    case -1:
    case -2:
      result.text = "Error publishing";
      break;
    default:
      result.text = "Your content is getting uploaded, currently in progress.";
      break;
  }
  return result.text;
};

export const mediaStatusTooltipText = (status: number): string => {
  const result = { text: "Tooltip Text" };
  switch (status) {
    case 0:
      result.text = "Saved as draft. Mark Active when you’re ready to publish.";
      break;
    case 1:
      result.text =
        "Marked Active — processing is in progress. It will publish when ready.";
      break;
    case 2:
      result.text =
        "Active and ready — the content is ready to be published on denmark & social platforms.";
      break;
    case 3:
      result.text =
        "Turned off — this content won’t be published until reactivated.";
      break;
    case -1:
      result.text = "Uploading failed. Retry or reupload to fix the issue.";
      break;
    case -2:
      result.text = "Removed from your repository — this content is deleted.";
      break;
    case -3:
      result.text = "Processing failed. Retry or reupload to fix the issue.";
      break;
    default:
      result.text = "Unknown";
      break;
  }

  return result.text;
};

export const mediaStatusToTextAndColor = (
  status: number
): {
  statusTextColor: string | undefined;
  statusText: string;
  statusColor: string;
} => {
  const result = {
    statusText: "unknown",
    statusColor: "red",
    statusTextColor: "#fff",
    tooltipText: "",
  };

  switch (status) {
    case 0:
      result.statusText = "Draft";
      result.statusColor = "draft";
      result.statusTextColor = "text-secondary";
      break;
    case 1:
      result.statusText = "Activating";
      result.statusColor = "processing";
      result.statusTextColor = "text-secondary";
      break;
    case 2:
      result.statusText = "Active";
      result.statusColor = "ready";
      result.statusTextColor = "text-secondary";
      break;
    case 3:
      result.statusText = "Inactive";
      result.statusColor = "bg-info";
      result.statusTextColor = "text-info";
      break;
    case -1:
      result.statusText = "Uploading Interrupted";
      result.statusColor = "bg-danger";
      result.statusTextColor = "text-danger";
      break;
    case -2:
      result.statusText = "Deleted";
      result.statusColor = "deleted";
      result.statusTextColor = "text-primary";
      break;

    case -3:
      result.statusText = "Error";
      result.statusColor = "bg-danger";
      result.statusTextColor = "text-danger";
      break;

    default:
      result.statusText = "Processing";
      result.statusColor = "processing";
      // result.statusTextColor = 'text-info';
      break;
  }

  return result;
};

export const socialPublishStatusToTextAndColor = (
  status: number
): { statusText: string; statusColor: string } => {
  const result = { statusText: "unknown", statusColor: "red" };

  switch (status) {
    case 0:
      result.statusText = "Draft";
      result.statusColor = "draft";
      break;
    case 12:
      // "Mark active" toggled off → staged/inactive, shown as Draft.
      result.statusText = "Draft";
      result.statusColor = "draft";
      break;
    case 1:
      result.statusText = "In Progress";
      result.statusColor = "processing";
      break;
    case 2:
      result.statusText = "In Progress";
      result.statusColor = "processing";
      break;
    case 3:
      result.statusText = "In Progress";
      result.statusColor = "processing";
      break;
    case 4:
      result.statusText = "In Progress";
      result.statusColor = "processing";
      break;
    case 5:
      result.statusText = "In Progress";
      result.statusColor = "processing";
      break;
    case 10:
      result.statusText = "Completed";
      result.statusColor = "completed";
      break;
    case -1:
      result.statusText = "Failed";
      result.statusColor = "bg-danger";
      break;
    case -2:
      result.statusText = "Failed";
      result.statusColor = "bg-danger";
      break;
    case -7:
      result.statusText = "Soft Deleted";
      result.statusColor = "bg-warning";
      break;
    case -4:
      result.statusText = "Hard Deleted";
      result.statusColor = "bg-secondary";
      break;
    default:
      result.statusText = "Unknown";
      result.statusColor = "draft";
      break;
  }

  return result;
};

export const AiTrasnformterScriptList = {};

export const AiTrasnformterScript = (script: string, type: string) => {
  const result = { script: "" };
  result.script =
    type === "title"
      ? AI_PROMPT_TITLE[script as keyof typeof AI_PROMPT_TITLE]
      : AI_PROMPT_DESC[script as keyof typeof AI_PROMPT_DESC];
  return result.script;
};

// const (
//   STATUS_USER_REQUEST_PENDING  = 0 // user request is pending
//   STATUS_USER_ACTIVE           = 1 // user is active
//   STATUS_USER_IN_ACTIVE        = 2 // user is inactive
//   STATUS_USER_REQUEST_REJECTED = 3 // user request is rejected
//   STATUS_USER_REQUEST_APPROVED = 4 // user request is approved
//   STATUS_USER_SERVICE_PENDING  = 5 // user service is pending
//   STATUS_USER_SERVICE_REJECTED = 6 // user service is rejected
//   STATUS_USER_SERVICE_APPROVED = 7 // user service is approved
// )

export const userStatusToTextAndColor = (status: number): string => {
  // STATUS_USER_STATUS = 0; // user status
  // STATUS_USER_REQUEST_PENDING = 0; // user request is pending
  // STATUS_USER_ACTIVE = 1; // user is active
  // STATUS_USER_IN_ACTIVE = 2; // user is inactive
  // STATUS_USER_REQUEST_REJECTED = 3; // user request is rejected
  // STATUS_USER_REQUEST_APPROVED = 4; // user request is approved
  // STATUS_MEDIA_STATUS = 5; // media uploading status
  // STATUS_SOCIAL_STATUS = 6; // social uploading status
  // STATUS_SERVICE_STATUS = 7; // service status
  // STATUS_USER_SERVICE_PENDING = 7; // user service is pending
  // STATUS_USER_SERVICE_REJECTED = 8; // user service is rejected
  // STATUS_USER_SERVICE_APPROVED = 9;

  switch (status) {
    case 0:
      return "Request Pending";
    case 1:
      return "Active";
    case 2:
      return "Inactive";
    case 3:
      return "Request Rejected";
    case 4:
      return "Request Approved";
    case 5:
      return "Media Status";
    case 6:
      return "Social Status";
    case 7:
      return "Service Pending";
    case 8:
      return "Service Rejected";
    case 9:
      return "Service Approved";
    default:
      return "Unknown";
  }
};

export const ButtonText = (status: number): string => {
  let result = "Unknown";
  switch (status) {
    case 100:
      result = "Publish";
      break;
    case -1:
      result = "Republish";
      break;
    case -2:
      result = "Republish";
      break;
    default:
      result = "Update";
      break;
  }
  return result;
};
